import './pricing-row.scss'
import PriceConverter, { convertCurrency } from '../../helpers/PriceConverter'
import FormInputNumber from '../../forms/final-form-fields/FormInputNumber'
import { Field } from 'react-final-form'
import messages from '../../../messages'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { trackGA4Ecommerce } from '../../../gtm'
import store from 'store2'

const CustomTooltip = () => {
  return (
    <div className='pricing-row__tooltip'>
      <FormattedMessage {...messages.pleaseSelect} />
    </div>
  )
}

function PricingRow({ name, item, showTooltip, maximumAvailability }) {
  const { price, comparePrice } = item
  const addRemoveToCartEventHandler = (value) => {
    const event = value > item.quantity ? 'add_to_cart' : 'remove_from_cart'
    const ecommerce = store.session('ecommerce')
    const convertedItemPrice = Number(
      convertCurrency(price.origin_value, price.origin_currency, 'USD').toFixed(
        2,
      ),
    )
    const ecommerceExtra = {
      item_id: item?.extra_option_id?.toString(),
      item_name: item?.title_en,
      item_brand: 'PADI',
      item_category: 'PADI Travel',
      item_category2: 'Extras',
      item_category3: '',
      item_category4: window.affiliateId,
      item_category5: '',
      item_variant: '',
      bundle_name: '',
      bundle_id: '',
      item_list_name: 'PADI Travel Adventures - Add Extras',
      price: convertedItemPrice,
      quantity: 1,
    }

    trackGA4Ecommerce(
      event,
      {
        currency: 'USD',
        value: convertedItemPrice,
        items: [name?.includes('participants') ? ecommerce : ecommerceExtra],
      },
      'PADI Travel - Adventures',
    )
  }
  return (
    <div className='pricing-row'>
      <div className='pricing-row__title'>{item.title}</div>
      <div className='pricing-row__price'>
        {comparePrice && comparePrice.origin_value !== price.origin_value && (
          <div className='pricing-row__compare-price'>
            <PriceConverter
              amount={comparePrice.origin_value}
              currency={comparePrice.origin_currency}
              decimals
              conversionPercent
            />
          </div>
        )}
        <div className='pricing-row__origin-price'>
          <PriceConverter
            amount={price.origin_value}
            currency={price.origin_currency}
            decimals
            conversionPercent
          />
        </div>
      </div>
      <div className='pricing-row__quantity'>
        <div className='input-counter relative'>
          {showTooltip && <CustomTooltip />}
          <Field name={name}>
            {(props) => (
              <FormInputNumber
                {...props}
                disabled
                maxNumber={maximumAvailability}
                plusMinusSeparate
                minNumber={0}
                onValueChange={addRemoveToCartEventHandler}
              />
            )}
          </Field>
        </div>
      </div>
    </div>
  )
}

export default PricingRow

PricingRow.propTypes = {
  name: PropTypes.string,
  item: PropTypes.object,
  showTooltip: PropTypes.bool,
  maximumAvailability: PropTypes.number,
  totalPrice: PropTypes.object,
}
